import React, { Component } from 'react';
import * as api from '../../../api';
import { ROUTING, SCHOOL_PART_TYPE, PATH } from '../../../constants';
import SchoolVideo from './SchoolVideo/SchoolVideo';
import './SchoolDetail.css';
import SchoolGallery from './SchoolGallery/SchoolGallery';
import SchoolArticle from './SchoolArticle/SchoolArticle';
import * as textHelper from '../../../utils/TextHelper';
import SchoolImage from './SchoolImage/SchoolImage';

// todo - maybe split sections (head, sections, footer) to separate components

class SchoolDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fetching: true,
      activeVideoKey: '',
      data: {},
    };

    this.handleVideoPlay = this.handleVideoPlay.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    api.getSchoolSheet(this.props.match.params.sheetId).then((data) => {
      this.setState({
        fetching: false,
        data,
      });
    }).catch(() => {
      // todo - solve error state
    });
  }

  componentDidUpdate(prevProps) {
    // for anchor-link function
    const anchorPrev = prevProps.match.params.anchor;
    const anchorActual = this.props.match.params.anchor;
    if (anchorPrev !== anchorActual) {
      if (anchorActual) {
        // note - best/quickest that we can do in this case
        // (using hash-router, which blocks normal anchor usage)
        // scroll
        document.getElementById(anchorActual).scrollIntoView();
        // reset prop
        this.props.history.replace(`${ROUTING.SCHOOL_DETAIL}/${this.props.match.params.sheetId}`);
      }
    }
  }

  // -------------------------------------------------------
  // Head
  // -------------------------------------------------------

  getHead(sheetId, headData) {
    const bullets = headData.goals.map((goal, index) => {
      const key = `${sheetId}-goal-${index}`;
      return (
        <li
          key={key}
          dangerouslySetInnerHTML={{ __html: textHelper.formatText(goal) }}
        />
      );
    });
    return (
      <div className="section head">
        <div className="wrap">
          <div className="title-main">{textHelper.formatText(headData.title)}</div>
          <img
            className="title-image"
            src={`${PATH.SCHOOL}img/${sheetId}/title.jpg`}
            alt={headData.title}
          />
          {headData.photoSource.length > 0 &&
          <div className="src">{headData.photoSource}</div>
          }
          <div
            className="desc"
            dangerouslySetInnerHTML={{ __html: textHelper.formatText(headData.desc) }}
          />
          <div className="title-bullets">Didaktický cíl</div>
          <ul>{bullets}</ul>
        </div>
      </div>
    );
  }

  // -------------------------------------------------------
  // Sections
  // -------------------------------------------------------

  getSectionPartText(key, data) {
    return (
      <div
        key={key}
        className="part text"
        dangerouslySetInnerHTML={{ __html: textHelper.formatText(data) }}
      />
    );
  }

  getSectionPartImage(sheetId, key, data) {
    return (
      <SchoolImage key={key} sheetId={sheetId} sectionData={data} />
    );
  }

  getSectionPartVideo(key, data) {
    return (<SchoolVideo
      key={key}
      videoId={key}
      videoActive={this.state.activeVideoKey === key}
      videoData={data}
      onPlayClick={this.handleVideoPlay}
    />);
  }

  getSectionPartBullets(key, data) {
    const bullets = data.map((bullet, index) => {
      const bulletKey = `${key}-${index}`;
      return (
        <li key={bulletKey} dangerouslySetInnerHTML={{ __html: textHelper.formatText(bullet) }} />
      );
    });
    return (
      <ul className="part bullets" key={key}>{bullets}</ul>
    );
  }

  getSectionPartGallery(sheetId, key, data) {
    return (
      <SchoolGallery key={key} sheetId={sheetId} sectionData={data} />
    );
  }

  getSectionPartArticle(sheetId, key, data) {
    return (
      <SchoolArticle key={key} sheetId={sheetId} sectionData={data} />
    );
  }

  getSectionPartDownload(key, data) {
    return (
      <a key={key} className="part download" href={`${PATH.SCHOOL}download/${data.file}`} target="_blank">{data.title}</a>
    );
  }

  getSectionPart(sheetId, partKey, partData) {
    switch (partData.type) {
      case SCHOOL_PART_TYPE.TEXT:
        return this.getSectionPartText(partKey, partData.data);
      case SCHOOL_PART_TYPE.IMAGE:
        return this.getSectionPartImage(sheetId, partKey, partData.data);
      case SCHOOL_PART_TYPE.VIDEO:
        return this.getSectionPartVideo(partKey, partData.data);
      case SCHOOL_PART_TYPE.BULLETS:
        return this.getSectionPartBullets(partKey, partData.data);
      case SCHOOL_PART_TYPE.GALLERY:
        return this.getSectionPartGallery(sheetId, partKey, partData.data);
      case SCHOOL_PART_TYPE.ARTICLE:
        return this.getSectionPartArticle(sheetId, partKey, partData.data);
      case SCHOOL_PART_TYPE.DOWNLOAD:
        return this.getSectionPartDownload(partKey, partData.data);
      default:
        return (<div>{`Undefined school section: ${partData.type}`}</div>);
    }
  }

  getSectionParts(sheetId, sectionKey, partsData) {
    const parts = partsData.map((part, index) =>
      this.getSectionPart(sheetId, `${sectionKey}-${index}`, part));
    return (
      <React.Fragment>{parts}</React.Fragment>
    );
  }

  getSections(sheetId, sectionsData) {
    const sections = sectionsData.map((section, index) => {
      const key = `${sheetId}-sekce-${index}`;
      return (
        <div key={key} id={key} className="section">
          <div className="wrap">
            <div className="title">{textHelper.formatText(section.title)}</div>
            {this.getSectionParts(sheetId, key, section.parts)}
          </div>
        </div>
      );
    });
    return (
      <div className="sections">
        {sections}
      </div>
    );
  }

  // -------------------------------------------------------
  // Foot
  // -------------------------------------------------------

  getFootLink(linkData) {
    if (linkData.url) {
      return (
        <a href={linkData.url} target="_blank">{linkData.title}</a>
      );
    }
    return (
      <div
        dangerouslySetInnerHTML={{ __html: textHelper.formatText(linkData.title) }}
      />
    );
  }

  getFootLinks(sheetId, linksData) {
    const links = linksData.map((link, index) => {
      const key = `${sheetId}-foot-link-${index}`;
      return (
        <li key={key}>
          {this.getFootLink(link)}
          {link.desc && link.desc.length > 0 &&
          <div className="desc">{textHelper.formatText(link.desc)}</div>
          }
        </li>
      );
    });
    return (
      <ul>{links}</ul>
    );
  }

  getFoot(sheetId, footData) {
    const sections = footData.map((section, index) => {
      const key = `${sheetId}-foot-section-${index}`;
      return (
        <div key={key}>
          <div className="title">{section.title}</div>
          {section.desc.length > 0 &&
          <div className="desc">{textHelper.formatText(section.desc)}</div>
          }
          {this.getFootLinks(sheetId, section.links)}
        </div>
      );
    });
    return (
      <div className="section foot">
        <div className="wrap">{sections}</div>
      </div>
    );
  }

  // -------------------------------------------------------
  // Handlers
  // -------------------------------------------------------

  handleVideoPlay(videoId) {
    this.setState({
      activeVideoKey: videoId,
    });
  }

  // -------------------------------------------------------
  // Render
  // -------------------------------------------------------

  render() {
    const { data } = this.state;
    const { sheetId } = this.props.match.params;

    return (
      <div className="school-detail">
        {!this.state.fetching &&
        <React.Fragment>
          {this.getHead(sheetId, data.head)}
          {this.getSections(sheetId, data.sections)}
          {this.getFoot(sheetId, data.footer)}
        </React.Fragment>
        }
      </div>
    );
  }
}

export default SchoolDetail;



// WEBPACK FOOTER //
// ./src/components/App/SchoolDetail/SchoolDetail.js